"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=e=>{window.location.href=e};exports.redirect=t;
//# sourceMappingURL=redirect.js.map
